<script>
	let submit = "";
	let message = "";
	let unknownError = "Something is not right. Please try again after sometime";
	let BASE_URL = (process.env.NODE_ENV === 'production') ? 'wr-app' : 'wr-app-staging';

	function downloadURI(uri) {
	  const link = document.createElement("a");
	  link.href = uri;
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	}

	async function submitPasscode() {
		const paths = window.location.pathname.split('/');
		let studyID;
		if (paths.length >= 1) {
			studyID = paths[1];
		} else {
			studyID = null;
		}

		const res = await fetch(`https://${BASE_URL}.whiterabbit.ai/api/v1/study/share/${studyID}/download/`, {
			method: 'GET',
		});

		const responseJSON = await res.json();

		if (res.ok) {
			if (responseJSON.success) {
				if (responseJSON.data && responseJSON.data.url) {
					downloadURI(responseJSON.data.url);
				} else {
					throw new Error(unknownError);
				}
			}
		} else {
			let message = responseJSON.message;
			if (message === 'invalid_share_id') {
				message = 'The link is no longer valid. Please ask the sender to share the study again';
			} else {
				message = unknownError;
			}
			throw new Error(message);
		}
	}
	submit = submitPasscode();
</script>

<style>
	.container {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.background {
		background-image: url("https://images.squarespace-cdn.com/content/v1/5ce592d94829d800019e8742/1560303275916-4YGMSN7C0BASXWS6PBIH/ke17ZwdGBToddI8pDm48kLkXF2pIyv_F2eUT9F60jBl7gQa3H78h4Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0iyqMbMesKd95J-X4EagrgU9L3Sa3U8cogeb0tjXbfawd0urKshkc5MgdBeJmALQKw/20190611+image+gradient+overlay_Homepage.jpg?format=2500w");
		background-repeat: no-repeat;
		background-position: center;
		position: absolute;
		z-index: -1;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-size: cover;
		background-color: #a36caf;
	}

</style>

<div class="container">
	<div class="background"></div>
		<img src="/wr-logo.png" style="width: 200px; height: auto" alt="Whiterabbit" />
	<div>

		{#await submit}
			<h4 class="white-text text-darken-2">Verifying the link...</h4>
		{:then data}
			<h4 class="white-text text-darken-2">The study is being downloaded</h4>
		{:catch error}
			<h4 class="white-text text-darken-2">
				{ error.message.indexOf('Unexpected token') > -1 ? unknownError : error.message }</h4>
		{/await}
	</div>
</div>
